import React from "react";
import { Search } from "lucide-react";
import { DatePicker } from "@/components/DatePicker";

export const EMPTY_FILTERS = { q: "", type: "todos", supplier: "", from: "", to: "" };

export const filterPurchases = (list, f) => {
  const t = f.q.trim().toLowerCase();
  return list.filter((p) => {
    const d = p.invoice_date || (p.timestamp || "").slice(0, 10);
    if (f.type !== "todos" && p.invoice_type !== f.type) return false;
    if (f.supplier && (p.supplier || "") !== f.supplier) return false;
    if (f.from && d < f.from) return false;
    if (f.to && d > f.to) return false;
    if (!t) return true;
    return (p.supplier || "").toLowerCase().includes(t) || (p.invoice_number || "").toLowerCase().includes(t)
      || p.items.some((i) => i.name.toLowerCase().includes(t) || (i.barcode || "").includes(t));
  });
};

const sel = "h-10 px-3 rounded-lg bg-secondary border border-border text-sm focus:border-primary focus:outline-none";

export const PurchaseFilters = ({ f, setF, suppliers }) => (
  <div className="flex flex-wrap items-center gap-2 mb-4" data-testid="purchase-filters">
    <div className="flex items-center gap-2 h-10 px-3 rounded-lg bg-secondary border border-border focus-within:border-primary flex-1 min-w-[220px]">
      <Search className="w-4 h-4 text-muted-foreground" />
      <input value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder="N° de factura, proveedor, producto o código…" data-testid="purchase-filter-search" className="flex-1 bg-transparent text-sm focus:outline-none" />
    </div>
    <select value={f.supplier} onChange={(e) => setF({ ...f, supplier: e.target.value })} data-testid="purchase-filter-supplier" className={sel}>
      <option value="">Todos los proveedores</option>
      {suppliers.map((s) => <option key={s} value={s}>{s}</option>)}
    </select>
    <select value={f.type} onChange={(e) => setF({ ...f, type: e.target.value })} data-testid="purchase-filter-type" className={sel}>
      <option value="todos">Todo comprobante</option><option value="con_factura">Con Factura</option><option value="sin_factura">Sin Factura</option>
    </select>
    <DatePicker value={f.from} onChange={(v) => setF({ ...f, from: v })} placeholder="Desde" testId="purchase-filter-from" />
    <DatePicker value={f.to} onChange={(v) => setF({ ...f, to: v })} placeholder="Hasta" testId="purchase-filter-to" />
  </div>
);
